import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import componentStyles from './idb-project-table-row.css.lit';

/**
 * The IdbProjectTableRow component
 * @element idb-project-table-row
 * @slot - stat-type - for adding a stat type
 * @slot - stat-data - for adding a stat data
 */
@customElement('idb-project-table-row')
export class IdbProjectTableRow extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <slot name='stat-type'></slot>
      <slot name='stat-data'></slot>
    `;
  }
}
